import { gql } from '@apollo/client'
import { graphql } from '@/gql'

export const FUTURE_DATA_FRAGMENT = graphql(`
  fragment FutureData on FutureDatum {
    id
    systemFieldId
    formFieldId
    formFieldEntryId
    userId
    updateValueAt
    createdAt
    value
    previousHumanReadableValue
    humanReadableValue
    approvalIsRequired
    hasBeenApproved
    hasBeenDenied
    creatorUser {
      id
      fullName
      logo
    }
    formField {
      id
      localizedName
      sensitive
    }
    systemField {
      id
      readableName
      localizedName
      companySystemField {
        id
        sensitive
      }
    }
    approvalId
    lastProcessedBy {
      id
      fullName
      logo
    }
  }
`)

export const FUTURE_DATA_FRAGMENT_EMPLOYEES_PAGE = gql`
  fragment FutureDataEmployeesPage on FutureDatum {
    id
    systemFieldId
    formFieldId
    formFieldEntryId
    userId
    updateValueAt
    createdAt
    value
    previousHumanReadableValue
    humanReadableValue
    approvalIsRequired
    hasBeenApproved
    hasBeenDenied
    creatorUser {
      id
      fullName
      logo
    }
    formField {
      id
      localizedName
      sensitive
    }
    systemField {
      id
      readableName
      companySystemField {
        id
        sensitive
      }
    }
    approvalId
    lastProcessedBy {
      id
      fullName
      logo
    }
  }
`
